<template>
  <div class="comContent">
    <div class="title">
      <div>
        <span class="font">商户类型</span>
      </div>
    </div>
    <div class="btns">
      <el-button size="small" type="primary" @click="addItem"> 新增 </el-button>
    </div>
    <div class="center">
      <MyTable
        :table-data="tableData"
        :showpage="false"
        :index="false"
        :operation="true"
        :table-option.sync="tableOption"
      >
        <template slot="riskCheck" slot-scope="scope">
          <el-switch
            v-model="scope.row.enableRisk"
            active-color="#f5222d"
            inactive-color="#8c8c8c"
            :active-value="1"
            :inactive-value="2"
            @change="changeRiskCheck(scope.row)"
          ></el-switch>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-link
            :underline="false"
            type="primary"
            @click="editItem(scope.row)"
            >编辑</el-link
          >
          <el-link
            style="margin-left: 16px"
            :underline="false"
            type="primary"
            @click="pushPage(scope.row)"
            >资质</el-link
          >
          <el-popconfirm title="确定删除吗？" @confirm="deleteItem(scope.row)">
            <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              slot="reference"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            v-if="scope.row.status == 1"
            style="margin-left: 16px"
            :underline="false"
            type="primary"
            @click="enableShopType(scope.row, true)"
            >启用</el-link
          >
          <el-link
            v-if="scope.row.status == 0"
            style="margin-left: 16px"
            :underline="false"
            type="primary"
            @click="enableShopType(scope.row, false)"
            >禁用</el-link
          >
        </template>
      </MyTable>
    </div>
    <ConfirmDialog
      :dialogShow="documentsDialogShow"
      :title="title"
      :showFooter="true"
      :width="800"
      @updateDialogShow="updateDialogShow"
      @confirm="confirm"
    >
      <el-form
        label-width="120px"
        :model="form"
        ref="form"
        class="form"
        :rules="formRules"
        size="mini"
        @submit.native.prevent
      >
        <el-form-item label="商户类型名称" prop="typeName">
          <el-input v-model="form.typeName" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input type="number" v-model="form.sort"></el-input>
        </el-form-item>
      </el-form>
    </ConfirmDialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";
import ConfirmDialog from "@/components/ConfirmDialog";
import {
  getListByType,
  saveOrUpdateShopTp,
  enableShopTp,
  deleteShopTp,
  switchRiskCheck,
} from "@/api/qualification/qualification";
export default {
  name: "QualificationDocumentsManager",
  components: { MyTable, ConfirmDialog },
  computed: {
    title() {
      if (this.type == "add") {
        return "新增商户类型";
      } else {
        return "编辑商户类型";
      }
    },
  },
  data() {
    return {
      type: "add", //add,edit
      documentsDialogShow: false,
      form: {
        typeName: "",
        sort: "",
      },
      formRules: {
        typeName: [
          { required: true, message: "请输入商户类型名称", trigger: "change" },
        ],
        sort: [
          { required: true, message: "请输入排序数字", trigger: "change" },
        ],
      },
      tableOption: [
        { label: "商户类型名称", prop: "typeName" },
        { label: "排序", prop: "sort" },
        { label: "风险校验", prop: "riskCheck", slot: true },
      ],
      tableData: [],
    };
  },
  methods: {
    changeRiskCheck(row) {
      switchRiskCheck({ typeCode: row.typeCode })
        .then((res) => {
          this.$message.success("操作成功");
        })
        .finally(() => {
          this.queryTable();
        });
    },
    queryTable() {
      getListByType({ type: 1 }).then((res) => {
        this.tableData = res.data;
      });
    },
    updateDialogShow(vis) {
      this.documentsDialogShow = vis;
    },
    resetForm() {
      this.form = {
        typeName: "",
        sort: "",
      };
    },
    initForm(row) {
      this.form = Object.assign(this.form, row);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            saveOrUpdateShopTp({
              type: 1,
              typeName: this.form.typeName,
              sort: this.form.sort,
            }).then((res) => {
              this.queryTable();
              this.$message.success("操作成功");
            });
          } else {
            saveOrUpdateShopTp({
              type: 1,
              typeName: this.form.typeName,
              typeCode: this.form.typeCode,
              sort: this.form.sort,
            }).then((res) => {
              this.queryTable();
              this.$message.success("操作成功");
            });
          }
          this.updateDialogShow(false);
        }
      });
    },
    addItem() {
      this.type = "add";
      this.resetForm();
      this.updateDialogShow(true);
    },
    editItem(row) {
      this.type = "edit";
      this.initForm(row);
      this.updateDialogShow(true);
    },
    enableShopType(row, type) {
      enableShopTp({ id: row.typeCode, enable: type }).then((res) => {
        this.$message.success("操作成功");
        this.queryTable();
      });
    },
    pushPage(row) {
      this.$router.push({
        path: "/qualification-related-user-management/qualification-merchant-documents",
        query: { typeCode: row.typeCode, typeName: row.typeName },
      });
    },

    deleteItem(row) {
      deleteShopTp({
        id: row.typeCode,
      }).then((res) => {
        this.$message.success("操作成功");
        this.queryTable();
      });
    },
  },
  mounted() {
    this.queryTable();
  },
};
</script>
<style lang="scss" scoped>
.comContent {
  padding: 0px;
  .title {
    height: 56px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f5f5ff;
  }
  .center {
    margin: 0 24px;
    margin-top: 16px;
    height: calc(100% - 131px);
    width: auto;
  }
  .btns {
    margin: 0 24px;
    margin-top: 16px;
  }
  .font-tip {
    padding-left: 10px;
    font-size: 12px;
    color: rgb(238, 214, 82);
  }
}
</style>
